import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Section from "../../../containers/Section";
import GradientTitle from "../../GradientTitle";
import Header, { HeaderVariant } from "../../Header";
import Paragraph from "../../Paragraph";
import Testimonal from "../../Testimonial";
import RecommendationSection from "./RecommendationSection";
import { PAGE } from "../../../constants/pages";

interface AudienceProps {
  title: string[];
  gradientPosition: number;
  description: string;
  testimonialsDescription?: string;
  testimonialsPerson?: string;
  testimonialsPersonTitle?: string;
  testimonialsPersonImage?: any;
  recommendations?: any;
  page?: string;
}

const AudienceSection: React.FC<AudienceProps> = props => {
  const {
    title,
    gradientPosition,
    description,
    testimonialsDescription,
    testimonialsPerson,
    testimonialsPersonTitle,
    testimonialsPersonImage,
    recommendations,
    page = "homepage"
  } = props;
  const images = useStaticQuery(graphql`
    query {
      headshot: file(relativePath: { eq: "headshots/megan-loveland.png" }) {
        childImageSharp {
          gatsbyImageData(width: 48, height: 48, layout: FIXED)
        }
      }
    }
  `);

  const testimonal = (
    <Testimonal
      quote={testimonialsDescription}
      name={testimonialsPerson}
      role={testimonialsPersonTitle}
      image={
        page !== PAGE.SELLICS_JOINS_PERPETUA &&
        images?.headshot?.childImageSharp?.gatsbyImageData
      }
    />
  );

  return (
    <div className="relative bg-gray-6-light rounded-tl-3xl">
      <Section>
        <div className="flex flex-col lg:flex-row">
          <div className="pt-20 text-center lg:text-left lg:pb-20 lg:pt-20 lg:w-1/2 self-center">
            <GradientTitle
              gradientPosition={gradientPosition}
              className=""
              color="purple"
              variant={HeaderVariant.h2}
              title={title}
              lineBreak={false}
            />
            <Paragraph className="text-2xl mb-11 lg:max-w-[35rem]">
              {description && description}
            </Paragraph>
            <div className="hidden lg:block">{testimonal}</div>
          </div>
          <div className="relative overflow-y-hidden w-full lg:w-1/2">
            <RecommendationSection
              page={page}
              recommendations={recommendations}
            />
          </div>
          {testimonal && (
            <div className="block pb-20 md:pb-24 lg:hidden">{testimonal}</div>
          )}
        </div>
      </Section>
    </div>
  );
};

export default AudienceSection;
